module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-nav"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndex),
      expression: "showIndex"
    }],
    attrs: {
      "to": "/homePage"
    }
  }, [_vm._v("首页 > ")]), _vm._v(" "), (_vm.data.type !== 2) ? _c('span', [(_vm.data.query) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.data.path,
        query: _vm.data.query
      }
    }
  }, [_vm._v(_vm._s(_vm.data.parentName))]) : _c('router-link', {
    attrs: {
      "to": {
        path: _vm.data.path
      }
    }
  }, [_vm._v(_vm._s(_vm.data.parentName))])], 1) : _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v(_vm._s(_vm.data.parentName))]), _vm._v(" >\n        "), _c('span', [_vm._v(_vm._s(_vm.data.childName))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2d6dc387"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsNav.vue
// module id = 816
// module chunks = 39